import { render, staticRenderFns } from "./ButtonMenu.vue?vue&type=template&id=41aabdb1&scoped=true&lang=pug"
import script from "./ButtonMenu.vue?vue&type=script&lang=ts"
export * from "./ButtonMenu.vue?vue&type=script&lang=ts"
import style0 from "./ButtonMenu.vue?vue&type=style&index=0&id=41aabdb1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aabdb1",
  null
  
)

export default component.exports